import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { getDefaultVsic } from '../../../helper'
import ScoreService from './ScoreService'

export const getCreditRiskScore = createAsyncThunk(
  'companyAnalysis/industryAnalysis/score/getCreditRiskScore',
  async (params, { rejectWithValue }) => {
    try {
      const {
        isDynamicReport,
        vsics = [],
        companyInfo = {},
        defaultIndustryId,
        compareIndustryId,
        ...others
      } = params

      if (isDynamicReport) {
        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id
        const newParams =
          companyInfo.companyType === COMPANY_TYPES.CORPORATE
            ? {
                DefaultVsicId: defaultVsicId,
                ComapreVsicId: compareIndustryId,
                ...others,
              }
            : others

        const res = await ScoreService.getCreditRiskScore(newParams)

        return res.success ? res.data : rejectWithValue({ isLoading: false })
      } else {
        const res = await ScoreService.getCreditRiskScore(others)

        return res.success ? res.data : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getPerformanceScore = createAsyncThunk(
  'companyAnalysis/industryAnalysis/score/getPerformanceScore',
  async (params, { rejectWithValue }) => {
    try {
      const {
        isDynamicReport,
        vsics = [],
        companyInfo = {},
        defaultIndustryId,
        compareIndustryId,
        ...others
      } = params

      if (isDynamicReport) {
        const defaultVsicId =
          defaultIndustryId || getDefaultVsic(vsics, companyInfo.mainVsicId).id
        const newParams =
          companyInfo.companyType === COMPANY_TYPES.CORPORATE
            ? {
                DefaultVsicId: defaultVsicId,
                ComapreVsicId: compareIndustryId,
                ...others,
              }
            : others

        const res = await ScoreService.getPerformanceScore(newParams)

        return res.success ? res.data : rejectWithValue({ isLoading: false })
      } else {
        const res = await ScoreService.getPerformanceScore(others)

        return res.success ? res.data : rejectWithValue({ isLoading: false })
      }
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
